import notFound from "./404.jpg";
import floorPlanScetch from "./mockup-gebaeude.jpg";
import team from "./team.jpg";

export { floorPlanScetch, notFound, team };
